import http from 'plugins/axios';

export default {
    getFocusPlateList(data) {
        return http.get({
            url: '/admin/focus/plate/list',
            data
        });
    },

    getFocusPlateBatchList(data) {
        return http.get({
            url: '/admin/focus/plate/batch',
            data
        });
    },

    getFocusPlateInfo(data) {
        return http.get({
            url: '/admin/focus/plate/info',
            data
        });
    },

    addFocusPlate(data) {
        return http.post({
            url: '/admin/focus/plate/create',
            data,
            dataType: 'form'
        });
    },

    updateFocusPlate(data) {
        return http.post({
            url: '/admin/focus/plate/update',
            data,
            dataType: 'form'
        });
    },

    deleteFocusPlate(data) {
        return http.post({
            url: '/admin/focus/plate/delete',
            data,
            dataType: 'form'
        });
    },

    getPlatePairList(data) {
        return http.get({
            url: '/admin/focus/platePair/list',
            data
        });
    },

    addPlatePair(data) {
        return http.post({
            url: '/admin/focus/platePair/create',
            data,
            dataType: 'form'
        });
    },

    updatePlatePair(data) {
        return http.post({
            url: '/admin/focus/platePair/update',
            data,
            dataType: 'form'
        });
    },

    deletePlatePair(data) {
        return http.post({
            url: '/admin/focus/platePair/delete',
            data,
            dataType: 'form'
        });
    },

    /**
     * 获取标签列表
     * @param data
     * @returns {*}
     */
    getLabelList(data) {
        return http.get({
            url: '/cms/cms/label/list',
            data
        })
    },

    /**
     * 获取推荐位列表
     * @param data
     * @returns {*}
     */
    getRecommendPositionList(data) {
        return http.get({
            url: '/cms/cms/recommend/position/list',
            data
        })
    },

    /**
     * 获取推荐位列表
     * @param data
     * @returns {*}
     */
    getPlateDetailLabelList(data) {
        return http.get({
            url: '/cms/cms/plate/detail/label/list',
            data
        })
    },

    /**
     * 获取推荐位列表
     * @param data
     * @returns {*}
     */
    getRecommendPositionByIds(data) {
        return http.get({
            url: '/cms/cms/recommend/position/batch',
            data
        })
    },

    /**
     * 获取可用交易对
     * @param data
     * @returns {*}
     */
    getAllSupportingPairs(data) {
        return http.get({
            url: '/cms/cms/review/pair',
            data
        })
    },

};
